import { SvgIcon, SvgIconProps } from "@mui/material";

export const CloseButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M18 6L6 18M6 6L18 18" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const QuickBoostPackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_32057_71264)">
        <path
          d="M1.33325 7.99988L7.7614 11.214C7.84886 11.2577 7.89259 11.2795 7.93845 11.2882C7.97908 11.2958 8.02076 11.2958 8.06139 11.2882C8.10725 11.2795 8.15098 11.2577 8.23843 11.214L14.6666 7.99988M1.33325 11.3332L7.7614 14.5473C7.84886 14.591 7.89259 14.6129 7.93845 14.6215C7.97908 14.6291 8.02076 14.6291 8.06139 14.6215C8.10725 14.6129 8.15098 14.591 8.23843 14.5473L14.6666 11.3332M1.33325 4.66655L7.7614 1.45247C7.84886 1.40874 7.89259 1.38688 7.93845 1.37827C7.97908 1.37065 8.02076 1.37065 8.06139 1.37827C8.10725 1.38688 8.15098 1.40874 8.23843 1.45247L14.6666 4.66655L8.23843 7.88062C8.15098 7.92435 8.10725 7.94621 8.06139 7.95482C8.02076 7.96244 7.97908 7.96244 7.93845 7.95482C7.89259 7.94621 7.84886 7.92435 7.7614 7.88062L1.33325 4.66655Z"
          stroke="#344054"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_32057_71264">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ProScoutPackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8.66674 1.33325L2.72904 8.45849C2.4965 8.73753 2.38023 8.87706 2.37846 8.99489C2.37691 9.09733 2.42256 9.19479 2.50224 9.25918C2.5939 9.33325 2.77552 9.33325 3.13876 9.33325H8.00007L7.3334 14.6666L13.2711 7.54135C13.5036 7.2623 13.6199 7.12278 13.6217 7.00494C13.6232 6.90251 13.5776 6.80505 13.4979 6.74066C13.4062 6.66659 13.2246 6.66659 12.8614 6.66659H8.00007L8.66674 1.33325Z"
        stroke="#344054"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
